import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SelectItemStore {

}

export enum SelectItemStoreKeys {

}
